import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';

@customElement('visual-optics')
export class VisualOptics extends LitElement {

	static styles = css`
	  :host {
		display: flex;
		  width: 100%;
	  }
	`;

	@property({type: Object})
	section = {};

	render() {
		return html`
			<svg-optics></svg-optics>
		`;
	}
}
